<template>
  <div id="detailView" class="sub-column" :class="{ 'sub-active' : relationOpen }">
    <div class="close-content"><div @click="closeDetailView" class="close-btn cursor"><i class="fa fa-angle-right"></i></div></div>
    <article class="sub-content-wrap">
      <section class="inner-wrap">
        <div class="s-inner-wrap">
            <div class="ibox-title flex-box fl-between ibox-detail-header">
              <span class="info-menu">
                <template>{{$t('addOkrStr')}}</template>
              </span>
              <span class="info-right"></span>
            </div>
            <div class="ib-sub-content">
                <div class="ibox-title search-box">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="input-group">
                                <input type="text" v-model="searchText" class="typeahead_2 form-control" :placeholder="$t('searchWithUserName')">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ibox-content search-resultview">
                    <ul v-if="searchText.length == 0">
                      <li v-if="getVisitedUsers.length === 0"><label>{{$t('notFoundUserStr')}}</label></li>
                      <li><label>{{$t('checkUserStrType')}}</label></li>
                      <template v-for="uid in getVisitedUsers" >
                        <li @click="onClickUser(uid,'user')" :key="uid">
                          <a href="#" data-toggle="modal" data-target="#relationModal">
                            <user-icon-name :user-id="uid" />
                          </a>
                          <span class="check-mark"></span>
                        </li>
                      </template>
                    </ul>
                    <ul v-else>
                      <li v-if="Object.keys(this.getUsersBySearchText).length === 0"><label>{{$t('notFoundUserStr')}}</label></li>
                      <div v-for="(user, key) in getUsersBySearchText" :key="user.id">
                        <li @click="onClickUser(key, user)" v-if="user.userInfo">
                          <a href="#" data-toggle="modal" data-target="#relationModal">
                            <span class="search-userimg">
                              <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                              <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                            </span>
                            <div class="search-userinfo">
                              <span class="search-username">{{user.userInfo.userName}}</span>
                              <span class="search-userdept">{{user.userInfo.dept}}</span>
                            </div>
                          </a>
                        </li>
                      </div>
                      </ul>
                  </div>
              </div>
          </div>
        </section>
      </article>
      <div>
        <transition name="fade">
          <div v-if="showModal" class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-container">
                <div class="modal-header">
                  <slot v-if="targetFrag" name="header">
                    <span class="search-userimg">
                      <img v-if="getUserInfoById(targetUserId).userIcon" :src="getUserInfoById(targetUserId).userIcon" alt="image" class="img-circle">
                      <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                    </span>
                    <div class="search-userinfo">
                      <span class="search-username">{{getUserInfoById(targetUserId).userName}}</span>
                      <span class="search-userdept">{{ getUserInfoById(targetUserId).dept }}</span>
                    </div>
                  </slot>
                </div>
                <div class="modal-body">
                  <div class="m-body-wrap">
                    <slot name="body">
                      <div v-for="(item, index) in getRelationObjectives" :key="index" v-if="checkRelationsFilter(item.obj, item.key)" :class="{'comp-mark' : getIsComp(item.obj)}" class="ibox">
                        <div @click="onClickAddRelationItem(item.obj, item.key, targetType)" class="ibox-title cursor">
                          <label>
                            <span class="check-mark"></span>
                            <objective :addMore="true" :itemId="item.key" :detailView="false" :content="item.obj.contentText" :progress="item.obj.progress ? item.obj.progress : '0'" :setReadOnly="'false'" :objective="true" />
                            <span class="due-date date-color">{{$t('dueDateStr')}} : {{item.obj.dueDate}}</span>
                            <div class="ibox-tools">
                              <span @click.stop.prevent="setRelationKeyresultOpen(item.key)" class="info-menu cursor">
                                <button class="btn btn-secondary">
                                  <i :class="{'chevronUp' : !getRelationIsOpen(item.key)}" class="fa fa-chevron-down"></i>
                                  <span v-if="!getRelationIsOpen(item.key)">{{$t('indicateItemClose')}}</span>
                                  <span v-else>{{$t('indicateAllNotice')}}</span>
                                </button>
                              </span>
                              <span class="info-right">
                                <span class="info-comment-detail">
                                  <img src="static/img/assets/comment.png">
                                  <span>{{getCommentsByItemId(item.key, targetType).length}}</span>
                                </span>
                                <span class="info-comment-detail">{{$t('createDateString')}} : {{item.obj.createdAt | preparedTime}}</span>
                              </span>
                            </div>
                          </label>
                        </div>
                      <div :class="{'keyResultClose' : getRelationIsOpen(item.key)}" class="ibox-content key-indent">
                        <div v-for="(keyresult, keyresultId) in getTargetKeyresults(item.key)" :key="keyresultId" v-if="checkRelationsFilter(keyresult, keyresultId)" class="ibox-child cursor" :class="{'comp-mark' : getIsComp(keyresult)}">
                          <div @click="onClickAddRelationItem(keyresult, keyresultId, targetType)" class="cursor"><label>
                            <div>
                              <span class="comp"></span>
                              <objective :addMore="true" :itemId="keyresultId" :detailView="false" :content="keyresult.contentText" :progress="keyresult.progress ? keyresult.progress : '0'" :setReadOnly="'false'" :objective="false" />
                            </div>
                            <span class="due-date date-color">{{$t('dueDateStr')}} : {{keyresult.dueDate}}</span>
                            <div class="ibox-tools">
                              <span class="info-menu"></span>
                              <span class="info-right">
                                <span class="info-comment-detail">
                                  <img src="static/img/assets/comment.png"><span>{{getCommentsByItemId(keyresultId,'keyresults').length}}</span>
                                </span>
                                <span class="info-comment-detail">{{$t('createDateString')}} : {{keyresult.createdAt|  preparedTime}}</span>
                              </span>
                            </div>
                          </label></div>
                        </div>
                      </div>
                    </div>
                  </slot>
                </div>
              </div>
              <div class="modal-footer">
                <slot name="footer">
                  <div class="row okr-regist-btnset">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-sm-offset-3"><button @click="onClickCancel" type="button" class="btn btn-danger block m-b">{{ $t('cancelStr') }}</button></div>
                  </div>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Objective from '@/components/Okr/Objective'
import CommentItem from '@/components/Comment/CommentItem'
import RelationItem from '@/components/Okr/RelationItem'
import UserIconName from '@/components/User/UserIconName'
import CommonJs from '@/js/common'
import moment from 'moment'

export default {
  name: 'OkrAddRelationDetailView',
  mixins: [CommonJs],
  components: {
    Objective,
    CommentItem,
    RelationItem,
    UserIconName
  },
  props: ['targetItemKey', 'targetType'],
  data: function () {
    return {
      targetItem: {},
      modalKeyresultOpen: {},
      searchText: '',
      showModal: false,
      open: false,
      relationOpen: false,
      targetUser: {},
      targetUserId: '',
      targetFrag: false
    }
  },
  watch: {
    targetItemKey () {
      if (this.targetType === 'objectives') {
        this.targetItem = this.getObjectiveById(this.targetItemKey, this.getUserId)
      } else if (this.targetType === 'keyresults') {
        this.targetItem = this.getKeyresultById(this.targetItemKey, this.getUserId)
      }
    }
  },
  computed: {
    ...mapGetters([
      'getUserId',
      'getCurrentUser'
    ]),
    ...mapGetters('okrs/', [
      'getRelationInfo'
    ]),
    ...mapGetters('keyResults/', [
      'getKeyresultsByParentObjId',
      'getKeyresultById'
    ]),
    ...mapGetters('objectives/', [
      'getObjectivesByUserId',
      'getObjectiveById'
    ]),
    ...mapGetters('comments/', [
      'getCommentsByItemId'
    ]),
    ...mapGetters('users/', [
      'getUsersByIds',
      'getUsersByText',
      'getUsersByIds',
      'getUserInfoById',
      'getUserById'
    ]),
    ...mapGetters('groups/', [
      'getGroupsByIds'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsDeleted'
    ]),
    getUsersBySearchText: function () {
      if (this.searchText.length === 0) {
        return {}
      } else {
        this.usersForRelation = this.getUsersByText(this.searchText)
        console.log('getUsersBySearchText: usersForRelation', this.usersForRelation)
        return this.getUsersByText(this.searchText)
      }
    },
    checkCanMoveDetailProgress: function () {
      if (this.targetType === 'objectives') {
        return 'true'
      } else if (this.targetType === 'keyresults') {
        return this.targetItem.isComplete ? 'false' : 'true'
      }
    },
    getVisitedUsers: function () {
      const currentUser = this.getCurrentUser
      console.log('getVisitedUsers:currentUser', currentUser)
      const visitHistory = Object.keys(currentUser.visitHistory || {})
      console.log('getVisitedUsers:visitHistory', visitHistory)
      const sortedRecentlyCheckedUsers = visitHistory.sort((a, b) => { return currentUser.visitHistory[b] - currentUser.visitHistory[a] }).filter(key => !this.getMetaIsDeleted(key))
      console.log('getVisitedUsers:sortedRecentlyCheckedUsers', sortedRecentlyCheckedUsers)
      return sortedRecentlyCheckedUsers
    },
    getTargetRelations: function () {
      const arrayRelations = []
      const objectRelations = this.targetItem.relations
      let chkKeys = {}
      for (const key in objectRelations) {
        let chkKey = [objectRelations[key].type, objectRelations[key].userId, objectRelations[key].key].join('_')
        if (key === '.key' || chkKeys[chkKey]) { continue }
        arrayRelations.push({key: key, relationItem: objectRelations[key]})
        chkKeys[chkKey] = true
      }
      console.log('arrayRelations.slice(0, this.relationCount)', arrayRelations.slice(0, this.relationCount))
      return arrayRelations.slice(0, this.relationCount)
    },
    getTargetComments () {
      return this.getCommentsByItemId(this.targetItemKey, this.targetType)
    },
    getTargetLimitedUsers () {
      return this.getUsersByIds(Object.keys(this.targetItem.limitedAccess.limitedUsers))
    },
    getTargetLimitedGroups () {
      if (this.targetItem.limitedAccess.limitedGroups) {
        return this.getGroupsByIds(Object.keys(this.targetItem.limitedAccess.limitedGroups))
      } else if (this.targetItem.limitedAccess.limitedGroup) {
        return this.getGroupsByIds([this.targetItem.limitedAccess.limitedGroup])
      }
    },
    getTargetLimitedAccess () {
      if (!this.targetItem.limitedAccess) {
        return {}
      } else if (this.targetItem.limitedAccess.limitedUsers) {
        return this.getUsersByIds(Object.keys(this.targetItem.limitedAccess.limitedUsers))
        // return !this.targetItem.limitedAccess.limitedGroup ? this.getUsersByIds(this.targetItem.limitedAccess.limitedUsers.keys) : this.targetItem.limitedAccess.limitedGroup
      } else if (this.targetItem.limitedAccess.limitedGroup) {
        return this.getGroupsByIds([this.targetItem.limitedAccess.limitedGroup])
      }
    },
    getRelationObjectives: function () {
      let relationOkrs = []
      console.log('trace:::getRelationObjectives', this.targetUserId, this.getObjectivesByUserId(this.targetUserId))
      if (this.targetUserId) {
        const relationOkrObj = this.getObjectivesByUserId(this.targetUserId)
        for (let key in relationOkrObj) {
          if (key === '.key') { continue }
          if (relationOkrObj[key] && relationOkrObj[key].contentText !== '') {
            if (!relationOkrObj[key].isComplete) {
              relationOkrs.push({key: key, obj: relationOkrObj[key]})
            } else if (relationOkrObj[key].isComplete === false) {
              relationOkrs.push({key: key, obj: relationOkrObj[key]})
            } else {
              continue
            }
          }
        }
        return relationOkrs.reverse()
      } else {
        return relationOkrs
      }
    }
  },
  methods: {
    ...mapActions('okrs/', {
      addRelation: 'ADD_RELATION'
    }),
    ...mapActions('peoples', {
      setVisit: 'SET_VISIT_HISTORY'
    }),
    relationsVisibilityChanged (isVisible, entry) {
      if (entry.isIntersecting && Number(entry.target.accessKey) === this.relationCount - 1) {
        this.relationCount += 10
      }
    },
    openDetailView () {
      this.relationOpen = true
      console.log('trace:::', this.relationOpen)
    },
    closeDetailView () {
      this.$emit('close-detail-view')
      this.relationOpen = false
    },
    getIsComp: function (item) {
      return Object.keys(item).filter(x => x === 'isComplete').length === 0 ? false : item.isComplete
    },
    getTargetKeyresults (key) {
      // 算出プロパティだと引数がつけられないためmethodに
      return this.getKeyresultsByParentObjId(key)
    },
    onClickAddRelationItem: function (item, key, type) {
      console.log('item, key, type', item, key, type)
      let targetRelations = {}
      if (type === 'objectives') {
        // 自分の関連OKR一覧を取得
        console.log('target Item :::', this.targetItemKey, this.getUserId)
        targetRelations = this.getObjectiveById(this.targetItemKey, this.getUserId).relations
        console.log('target objective:::', targetRelations)
      } else if (type === 'keyresults') {
        console.log('target Item :::', this.targetItemKey, this.getUserId)
        targetRelations = this.getKeyresultById(this.targetItemKey, this.getUserId).relations
        console.log('target keyresult:::', targetRelations)
      }
      // 関連OKRがある場合
      if (targetRelations) {
        for (const relationKey in targetRelations) {
          // 1個ずつ取り出す
          let relationItem = targetRelations[relationKey]
          console.log('data', relationItem, type, key)
          // 取り出した自分のアイテム、自身のタイプ、クリックしたアイテムのkey
          if (relationItem.key === key) {
            // 取り出した自分のアイテムのkeyが、クリックしたアイテムのkeyと一致する場合
            this.$swal({
              text: this.$t('alreadySetup'),
              type: 'warning',
              animation: false,
              customClass: 'animated fadeInUp',
              // customClass: 'animated flipInX',
              width: '35rem',
              position: 'center',
              // toast: true,
              padding: '2rem',
              timer: 3000
            })
            return
          }
        }
      }
      let targetIdUserIds = []
      targetIdUserIds[0] = {
        targetId: key,
        userId: this.targetUserId
        // type: type
      }
      if (item.parentObjId) {
        targetIdUserIds[0].type = 'keyresults'
      } else {
        targetIdUserIds[0].type = 'objectives'
      }
      const userInfos = {
        [this.targetUserId]: {
          'userInfo': this.getUserInfoById(this.targetUserId)
        }
      }
      let value = {
        'relationInfo': this.getRelationInfo(targetIdUserIds, userInfos)[0],
        'type': this.targetType,
        'key': this.targetItemKey
      }
      console.log('追加する関連アイテム:::', value)
      this.$swal({
        title: this.$t('addStr'),
        text: this.$t('popMessageStr20'),
        type: 'question',
        showCancelButton: true,
        cancelButtonColor: '#f64846',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        reverseButtons: false,
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        allowOutsideClick: false,
        padding: '2rem'
        // timer: 3000
      }).then((result) => {
        if (result.value) {
          this.addRelation(value).then(
            this.$swal({
              title: this.$t('compStorageStr'),
              type: 'success',
              animation: false,
              customClass: 'animated fadeInUp',
              // customClass: 'animated flipInX',
              width: '35rem',
              position: 'center',
              // toast: true,
              padding: '2rem',
              timer: 4000
            }).then((willClose) => {
              this.open = true
              this.relationOpen = false
              this.$emit('close-detail-view')
            })
          )
          this.setVisit(this.targetUserId)
          this.showModal = false
        } else {
          console.log('confirmDeletePictureStr -> false')
        }
      })
    },
    onClickCancel: function () {
      this.showModal = false
      // this.open = true
    },
    getRelationIsOpen: function (objectiveId) {
      return Object.keys(this.modalKeyresultOpen).filter(x => x === objectiveId).length === 0 ? false : this.modalKeyresultOpen[objectiveId]
    },
    onClickUser: function (key, user) {
      let objectives = this.getObjectivesByUserId(key)
      if (user === 'user') {
        user = this.getUserById(key)
      }
      let count
      let $t = this.$t
      let currentUserId = this.getCurrentUser['.key']
      // console.log('getOnClickUserOkrs::', this.getObjectivesByUserId(key))
      if (Object.keys(objectives).length === 0) {
        this.$swal({
          title: $t('popTitleStrType'),
          text: $t('noObjective'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
        return
      }
      if ((key === currentUserId) || (!this.targetItem.limitedAccess) || ((this.targetItem.limitedAccess) &&
        ((this.targetItem.limitedAccess.limitedUsers && this.targetItem.limitedAccess.limitedUsers[key]) ||
          (this.targetItem.limitedAccess.limitedGroup && this.getTargetLimitedAccess[this.targetItem.limitedAccess.limitedGroup].members[key]) ||
          (this.targetItem.limitedAccess.limitedGroups && Object.keys(user.groups).filter(x => Object.keys(this.targetItem.limitedAccess.limitedGroups).includes(x)).length > 0)))) {
        count = Object.keys(objectives).length
        for (let id in objectives) {
          console.log('obj::', id, this.targetItemKey)
          if (id === this.targetItemKey || objectives[id].isComplete) {
            count = count - 1
          } else if (this.getKeyresultById(this.targetItemKey, this.getUserId) && this.getKeyresultById(this.targetItemKey, this.getUserId).parentObjId && id === this.getKeyresultById(this.targetItemKey, this.getUserId).parentObjId) {
            count = count - 1
          }
        }
        if (count > 0) {
          this.targetUserId = key
          this.targetUser = user
          this.showModal = true
          this.targetFrag = true
          console.log('trace:::count>0', this.targetUserId, this.targetUser, this.showModal)
          return
        } else {
          this.$swal({
            title: $t('popTitleStrType'),
            text: $t('noObjective'),
            type: 'warning',
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            padding: '2rem',
            timer: 3000
          })
        }
        return
      }
      this.$swal({
        title: $t('popTitleStrType'),
        html: '公開範囲にユーザーが含まれていません。',
        type: 'warning',
        animation: false,
        customClass: 'animated fadeInUp',
        width: '35rem',
        position: 'center',
        padding: '2rem'
      })
    },
    checkRelationsFilter: function (obj, objectiveId) {
      console.log('trace:::checkRelationsFilter', obj, objectiveId)
      if (this.targetItem.parentObjId) {
        if (obj.contentText && !obj.isComplete && this.targetItemKey !== objectiveId && this.targetItem.parentObjId !== objectiveId) return true
        else return false
      } else {
        if (obj.contentText && !obj.isComplete && this.targetItemKey !== objectiveId) return true
        else return false
      }
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .flex-option{
    display: flex;
    flex-direction: column;
  }

  .keyResultClose .ibox-child {
    height: 0;
    margin: 0 auto;
    padding-top: 0;
    padding-bottom: 0;
    overflow:  hidden;
    border: none;
  }
  .swal2-container {
    z-index: 100000;
  }
  .fa-chevron-down{
    transition: all 0.2s ease-in-out;
  }
  .chevronUp{
    transform: rotate(180deg);
  }
  .modal-enter-active, .modal-leave-active {
    transition: all .2s ease ;
  }
  .modal-enter, .modal-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/DetailView/OkrAddRelationDetailView.vue